import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {SubReportComponent, SubReportElementComponent, SubReportFilter} from '../fields-interventions-general-ii-report.component';
import {Workbook, Worksheet} from 'exceljs';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {DxDataGridComponent} from 'devextreme-angular';
import {Tractor, Trailer, durationToStr} from 'shared';
import {TractorService} from '../../../../../stores/tractor.service';
import {TrailerService} from '../../../../../stores/trailer.service';
import moment from 'moment';
import {UserDomainService} from '../../../../../user-domains/user-domain.service';
import {UserDomain} from '../../../../../user-domains/user-domain';
import {sortBy, groupBy, map, sumBy, flatten, filter as f} from 'lodash';
import {Util} from 'leaflet';
import indexOf = Util.indexOf;

@Component({
  selector: 'app-material-park-data',
  templateUrl: './material-park-data.component.html',
  styleUrls: ['./material-park-data.component.scss'],
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportComponent.outputs,
})
export class MaterialParkDataComponent extends SubReportComponent implements OnInit {
  tractors: Tractor[];
  trailers: Trailer[];
  domains: UserDomain[];

  constructor(
    private tractorService: TractorService,
    private trailerService: TrailerService,
    private userDomainsService: UserDomainService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.title = `${this.romainIndex}. DONNEES TECHNIQUES PARC MATERIEL`;

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: workBook => this.export(workBook),
      loader: (isReload, filter, data) => this.load(isReload, filter, data)
    });
  }

  async load(isReload: boolean, filter: SubReportFilter, data): Promise<any> {

    const ids = filter.domainIds();
    const options = {
      paginate: false,
      filter: ['domain_id', '=', ids],
    };

    /*this.domains = await this.userDomainsService.userDomainsWithAreas().toPromise();
    this.tractors = await this.tractorService.newDataSource(options).load();
    this.trailers = await this.trailerService.newDataSource(options).load();*/

    const d = await Promise.all([
      this.userDomainsService.userDomainsWithAreas().toPromise(),
      this.tractorService.newDataSource(options).load(),
      this.trailerService.newDataSource(options).load(),
    ]);

    return super.load(isReload, filter, d);
  }

  getWorkSheetName(): string {
    return this.title;
  }

}

/* -----------------------------------------
-- Table 1
-------------------------------------------- */
@Component({
  selector: 'app-material-park-data-table-1',
  template: `
    <dx-data-grid
      class="p-4"
      [columnAutoWidth]="true"
      width="90%"
      [showBorders]="true">
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-export [enabled]="true"></dxo-export>
    </dx-data-grid>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialParkDataTable1Component extends SubReportElementComponent implements OnInit {

  @ViewChild(DxDataGridComponent)
  grid: DxDataGridComponent;

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });
  }

  load(isReload: boolean, filter: SubReportFilter, [domains, tractors, trailers]) {
    const hasMultipleDomains = filter.domains.length > 1;
    this.ds = [];
    const data = this.store.createQuery().groupBy('vehicle_id').toArray();
    // Taux d’amortissement : noté « tx »
    const N = 10; // Todo: adjust it
    const tx = 100 / N;
    tractors.forEach(t => {
      if (t.is_subcontract) {
        return;
      }
      // k constitue le nombre de mois passé depuis l’acquisition de l’immobilisation
      const k = moment().diff(moment(t.acquisition_date), 'months', true);
      const CA = t.acquisition_value * (tx / 100) * (k / 12);
      const interventions = data.find(i => i.key === t.id) || {items: []};
      const item = {
        Tracteur: t.name,
        Categorie: t.engine_power_category,
        'Cumul horaire  H': durationToStr(interventions.items.reduce((sum, ii) => {
          return sum + ii.total_working_duration;
        }, 0)),
        'Age moyen ans': t.age,
        'Valeur achat Dh': t.acquisition_value,
        'VNA Dh': t.acquisition_value > CA ? Math.round(t.acquisition_value - CA) : 0,
      };
      if (hasMultipleDomains) {
        // @ts-ignore
        item.Domaine = t.domain_name;
        // @ts-ignore
        item.BU = t.business_unit_name;
      }
      this.ds.push(item);
    });
    this.grid.instance.option('dataSource', this.ds);
    return Promise.resolve(undefined);
  }
}

/* -----------------------------------------
-- Table 2
-------------------------------------------- */
@Component({
  selector: 'app-material-park-data-table-2',
  template: `
    <dx-data-grid
      class="p-4"
      [columnAutoWidth]="true"
      [grouping]="{contextMenuEnabled: true, autoExpandAll: false}"
      width="90%"
      [showBorders]="true">
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-export [enabled]="true"></dxo-export>
      <dxo-summary>
        <dxi-total-item
          column="Nbr tracteur"
          displayFormat="{0}"
          summaryType="sum">
        </dxi-total-item>

        <dxi-total-item
          column="Surface domaine"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          displayFormat="{0}"
          summaryType="avg">
        </dxi-total-item>

        <dxi-total-item
          column="Degré  mecanisation Cv/Ha"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-total-item>

        <dxi-total-item
          column="Ha/ Unité tracteur"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-total-item>

        <dxi-group-item
          column="Nbr tracteur"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          displayFormat="{0}"
          summaryType="sum">
        </dxi-group-item>

        <dxi-group-item
          column="Surface domaine"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          displayFormat="{0}"
          summaryType="avg">
        </dxi-group-item>

        <dxi-group-item
          column="Degré  mecanisation Cv/Ha"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-group-item>

        <dxi-group-item
          column="Ha/ Unité tracteur"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-group-item>
      </dxo-summary>
    </dx-data-grid>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialParkDataTable2Component extends SubReportElementComponent implements OnInit {

  @ViewChild(DxDataGridComponent)
  grid: DxDataGridComponent;

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, ff, data) => this.load(isReload, ff, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });
  }

  load(isReload: boolean, ff, [domains, all, trailers]) {
    const hasMultipleDomains = ff.domains.length > 1;
    const ids = ff.domainIds();
    const tractors = f(all, (t) => ids.indexOf(t.domain_id) !== -1);
    this.ds = flatten(map(groupBy(tractors, 'domain_id'), (g, domainID) => {
      const domain = domains.find((d) => d.id.toString() === domainID);
      if (!domain) {
        return {};
      }
      return map(groupBy(g, 'engine_power_category'), (gg, epg) => {
        const totalCV = sumBy(gg, (t) => t.engine_power);
        return {
          Domaine: domain.name,
          Puissance: epg,
          'Nbr tracteur': gg.length,
          'Surface domaine': Math.round(domain.total_area),
          'Degré  mecanisation Cv/Ha': parseFloat((totalCV / domain.total_area).toFixed(3)),
          'Ha/ Unité tracteur': parseFloat((domain.total_area / gg.length).toFixed(3)),
          BU: gg[0].business_unit_name,
        };
      });
    }));
    this.grid.instance.on('contentReady', () => {
      this.grid.instance.columnOption(0,
        hasMultipleDomains ? {groupIndex: 0, visible: true} : {groupIndex: null, visible: false});
      /*this.grid.instance.columnOption(1, {format: {type: 'fixedPoint', precision: 2}});
      this.grid.instance.columnOption(2, {format: {type: 'fixedPoint', precision: 2}});
      this.grid.instance.columnOption(3, {format: {type: 'fixedPoint', precision: 2}});*/


      this.grid.instance.off('contentReady');
    });
    this.grid.instance.option('dataSource', this.ds);

    return Promise.resolve(undefined);
  }
}

/* -----------------------------------------
-- Table 3
-------------------------------------------- */
@Component({
  selector: 'app-material-park-data-table-3',
  template: `
    <dx-data-grid
      class="p-4"
      [columnAutoWidth]="true"
      width="90%"
      [grouping]="{contextMenuEnabled: true, autoExpandAll: false}"
      [showBorders]="true">
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-export [enabled]="true"></dxo-export>
      <dxo-summary>

        <dxi-total-item
          column="Nbre"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="sum">
        </dxi-total-item>

        <dxi-total-item
          column="Age moyen"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-total-item>

        <dxi-total-item
          column="Ha/ Unité tracteur"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-total-item>

        <dxi-total-item
          column="Cumul heures fonctionnement"
          displayFormat="{0}"
          [valueFormat]="durationToStr"
          summaryType="sum">
        </dxi-total-item>

        <dxi-group-item
          column="Ha/ Unité tracteur"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-group-item>

        <dxi-group-item
          column="Nbre"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="sum">
        </dxi-group-item>

        <dxi-group-item
          column="Age moyen"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          displayFormat="{0}"
          [valueFormat]="{type: 'fixedPoint', precision: 2}"
          summaryType="avg">
        </dxi-group-item>

        <dxi-group-item
          column="Cumul heures fonctionnement"
          [showInGroupFooter]="false"
          [alignByColumn]="true"
          displayFormat="{0}"
          [valueFormat]="durationToStr"
          summaryType="sum">
        </dxi-group-item>
      </dxo-summary>
    </dx-data-grid>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialParkDataTable3Component extends SubReportElementComponent implements OnInit {

  @ViewChild(DxDataGridComponent)
  grid: DxDataGridComponent;

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });
  }

  load(isReload: boolean, filter, [domains, tractors, oTrailers]) {
    const hasMultipleDomains = filter.domains.length > 1;
    const ids = filter.domainIds();
    const trailers = f(oTrailers, (t) => ids.indexOf(t.domain_id) !== -1);
    const interventions = groupBy(this.store.createQuery().toArray(), (t) => {
      return t.trailer_name.split(' ')[0].toLowerCase();
    });
    this.ds = flatten(map(groupBy(trailers, 'domain_id'), (g, domainID) => {
      const domain = domains.find((d) => d.id.toString() === domainID);
      if (!domain) {
        return {};
      }
      return map(groupBy(g, (t) => {
        return t.name.split(' ')[0].toLowerCase();
      }), (gg, name) => {
        const sumAges = sumBy(gg, t => t.age);
        const trailerInterventions = interventions[name] || [];
        return {
          Domaine: domain.name,
          'Machines et outils': name.charAt(0).toUpperCase() + name.slice(1),
          Nbre: gg.length,
          'Ha/ Unité tracteur': parseFloat((domain.total_area / gg.length).toFixed(3)),
          'Age moyen': parseFloat((sumAges / gg.length).toFixed(3)),
          'Cumul heures fonctionnement': durationToStr(trailerInterventions.reduce((sum, ii) => {
            return sum + ii.total_working_duration;
          }, 0)),
          BU: gg[0].business_unit_name,
        };
      });
    }));

    this.grid.instance.on('contentReady', () => {
      this.grid.instance.columnOption(0,
        hasMultipleDomains ? {groupIndex: 0, visible: true} : {groupIndex: null, visible: false});

      this.grid.instance.off('contentReady');
    });
    this.grid.instance.option('dataSource', this.ds);

    return Promise.resolve(undefined);
  }

  durationToStr(value) {
    return durationToStr(value);
  }
}

/* -----------------------------------------
-- Chart 1
-------------------------------------------- */
@Component({
  selector: 'app-material-park-data-chart-1',
  template: `
    <dx-accordion
      class="p-4"
      width="90%"
      [dataSource]="ds"
      [collapsible]="false"
      [multiple]="false"
      [animationDuration]="300">
      <div *dxTemplate="let d of 'title'">
        <h4 class="group-title">{{d.title}}</h4>
      </div>
      <div *dxTemplate="let d of 'item'">
        <dx-pie-chart
          class="p-2 m-auto w-1/2"
          palette="bright"
          [size]="{width: 520,  height: 500}"
          [dataSource]="d.data">
          <dxo-legend
            orientation="horizontal"
            itemTextPosition="right"
            horizontalAlignment="center"
            verticalAlignment="bottom"
            [columnCount]="4"></dxo-legend>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-title [text]="d.title">
            <dxo-font [size]="20" [weight]="300" color="black"></dxo-font>
          </dxo-title>
          <dxi-value-axis [visible]="false"></dxi-value-axis>
          <dxi-series
            argumentField="Age"
            valueField="Nb">
            <dxo-label
              [visible]="true"
              position="columns"
              [customizeText]="customizeLabel">
              <dxo-font [size]="12"></dxo-font>
              <dxo-connector
                [visible]="true"
                [width]="0.5"></dxo-connector>
            </dxo-label>
          </dxi-series>
        </dx-pie-chart>
      </div>
    </dx-accordion>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialParkDataChart1Component extends SubReportElementComponent implements OnInit {

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    /*workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });*/

    return Promise.resolve(undefined);
  }

  load(isReload: boolean, filter, [domains, all, oTrailers]) {
    const hasMultipleDomains = filter.domains.length > 1;
    const ages = ['< 5ans', '5-10 ans', '10-14 ans', '> 14 ans'];
    const ids = filter.domainIds();
    const tractors = f(all, (t) => ids.indexOf(t.domain_id) !== -1);
    this.ds = map(groupBy(tractors, 'domain_name'), (g, domainName) => {
      return {
        domain: domainName,
        title: domainName + ': Age des tracteurs consolidé',
        data: sortBy(map(groupBy(g, t => {
          if (t.age < 5) {
            return '< 5ans';
          } else if (t.age < 10) {
            return '5-10 ans';
          } else if (t.age < 14) {
            return '10-14 ans';
          } else {
            return '> 14 ans';
          }
        }), (gg, age) => {
          return {
            Age: age,
            Nb: gg.length,
          };
        }), a => ages.indexOf(a.Age))
      };
    });

    if (hasMultipleDomains) {
      this.ds.unshift({
        domain: 'Total',
        title: 'Total: Age des tracteurs consolidé',
        data: sortBy(map(groupBy(tractors, t => {
          if (t.age < 5) {
            return '< 5ans';
          } else if (t.age < 10) {
            return '5-10 ans';
          } else if (t.age < 14) {
            return '10-14 ans';
          } else {
            return '> 14 ans';
          }
        }), (gg, age) => {
          return {
            Age: age,
            Nb: gg.length,
          };
        }), a => ages.indexOf(a.Age))
      });
    }

    return Promise.resolve(undefined);
  }

  customizeLabel(arg) {
    return arg.value + ' (' + arg.percentText + ')';
  }
}


/* -----------------------------------------
-- Chart 2
-------------------------------------------- */
@Component({
  selector: 'app-material-park-data-chart-2',
  template: `
    <dx-accordion
      class="p-4"
      width="90%"
      [dataSource]="ds"
      [collapsible]="false"
      [multiple]="false"
      [animationDuration]="300">
      <div *dxTemplate="let d of 'title'">
        <h4 class="group-title">{{d.title}}</h4>
      </div>
      <div *dxTemplate="let d of 'item'">
        <dx-chart
          [dataSource]="d.data">
          <dxi-series valueField="Moyenne" name="Moyenne"></dxi-series>
          <dxi-series valueField="Nbre" name="Nbre"></dxi-series>

          <dxo-title [text]="d.title">
            <dxo-font [size]="20" [weight]="300" color="black"></dxo-font>
          </dxo-title>
          <dxo-common-series-settings
            argumentField="Puissance"
            type="bar"
            hoverMode="allArgumentPoints"
            selectionMode="allArgumentPoints">
            <dxo-label
              [visible]="true"
              [format]="{
                type: 'fixedPoint',
                precision: '0'
            }">
            </dxo-label>
          </dxo-common-series-settings>

          <dxi-value-axis
            name="Moyenne"
            position="left">
            <dxo-grid [visible]="true"></dxo-grid>
            <dxo-title text="Puissance Moyenne"></dxo-title>
          </dxi-value-axis>
          <dxi-value-axis
            name="Nbre"
            position="right">
            <dxo-grid [visible]="true"></dxo-grid>
            <dxo-title text="Nbre des Tracteurs"></dxo-title>
          </dxi-value-axis>
          <dxo-legend
            verticalAlignment="bottom"
            horizontalAlignment="center">
          </dxo-legend>
          <dxo-export [enabled]="true"></dxo-export>
        </dx-chart>
      </div>
    </dx-accordion>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialParkDataChart2Component extends SubReportElementComponent implements OnInit {

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    /*workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });*/
    return Promise.resolve(undefined);
  }

  load(isReload: boolean, filter, [domains, all, oTrailers]) {
    const hasMultipleDomains = filter.domains.length > 1;
    const ids = filter.domainIds();
    const tractors = f(all, (t) => ids.indexOf(t.domain_id) !== -1);
    this.ds = map(groupBy(tractors, 'domain_name'), (g, domainName) => {
      return {
        domain: domainName,
        title: domainName + ': Nbre de tracteurs et puissance moyenne',
        data: map(groupBy(g, 'engine_power_category'), (gg, ep) => {
          const totalCV = sumBy(gg, (t) => t.engine_power);
          return {
            Puissance: ep,
            Moyenne: Math.round(totalCV / gg.length),
            Nbre: gg.length,
          };
        })
      };
    });

    if (hasMultipleDomains) {
      this.ds.unshift({
        domain: 'Total',
        title: 'Total: Nbre de tracteurs et puissance moyenne',
        data: map(groupBy(tractors, 'engine_power_category'), (gg, ep) => {
          const totalCV = sumBy(gg, (t) => t.engine_power);
          return {
            Puissance: ep,
            Moyenne: Math.round(totalCV / gg.length),
            Nbre: gg.length,
          };
        })
      });
    }

    return Promise.resolve(undefined);
  }

  customizeLabel(arg) {
    return arg.value + ' (' + arg.percentText + ')';
  }
}
